import React, { Component, createElement } from "react";
import { func, string, shape } from "prop-types";
import Select from "react-select";
import { format } from "date-fns";

import I18n from "pages/_components/I18n";
import PeriodFilter from "pages/accounts/_components/PeriodFilter";
import TextField from "pages/_components/fields/TextField";
import SearchByFilter from "pages/accounts/_components/SearchByFilter";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import * as i18n from "util/i18n";
import { connect } from "react-redux";
import AmountField from "pages/_components/fields/formik/AmountField";
import { isIOS } from "react-device-detect";
import AmountFilter from "./AmountFilter";

const components = {
    period: PeriodFilter,
    amount: AmountFilter,
    receipt: SearchByFilter,
    detail: SearchByFilter,
};

class MoreFilters extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        productId: string.isRequired,
        setBalanceFalse: func.isRequired,
        setBalanceTrue: func.isRequired,
        parentSelectedFilter: string.isRequired,
        filtersGlobal: shape({}).isRequired,
        handleClickHideFilters: func.isRequired,
        currency: string.isRequired,
    };

    state = {
        selectedFilter: "period",
    };

    componentDidMount() {
        const { filtersGlobal } = this.props;

        if (filtersGlobal?.selectedFilter) {
            this.setState({ selectedFilter: filtersGlobal?.selectedFilter });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { parentSelectedFilter } = nextProps;

        if (parentSelectedFilter === "pending") {
            this.setState({ selectedFilter: "period" });
        }
    }

    handleDownloadClick = () => {
        const { dispatch, productId, parentSelectedFilter, filtersGlobal } = this.props;

        if (filtersGlobal?.channels) {
            return;
        }

        const startDate = filtersGlobal.dateFrom ? format(filtersGlobal.dateFrom, "YYYY-MM-DD") : "";
        const endDate = filtersGlobal.dateTo ? format(filtersGlobal.dateTo, "YYYY-MM-DD") : "";

        switch (parentSelectedFilter) {
            case "pending":
                dispatch(
                    accountsActions.downloadPendingMovements(
                        { idAccount: productId, dateFrom: startDate, dateTo: endDate },
                        "pdf",
                    ),
                );
                break;
            case "lastMonth":
                dispatch(accountsActions.downloadMovements(productId, "pdf"));
                break;
            default:
                break;
        }
    };

    handleChange = (selectedOption) => {
        this.setState({ selectedFilter: selectedOption.value });
    };

    searchByField = () => {
        const { selectedFilter } = this.state;

        const { parentSelectedFilter } = this.props;

        const options = [
            {
                value: "period",
                label: i18n.get("accounts.movements.filters.searchBy.period"),
            },
        ];

        if (parentSelectedFilter !== "pending") {
            options.push(
                {
                    value: "amount",
                    label: i18n.get("accounts.movements.filters.searchBy.amount"),
                },
                {
                    value: "receipt",
                    label: i18n.get("accounts.movements.filters.searchBy.receipt"),
                },
                {
                    value: "detail",
                    label: i18n.get("accounts.movements.filters.searchBy.detail"),
                },
            );
        }

        return (
            <div className={isIOS ? "form-group form-group--select px-0 py-0" : "form-group form-group--select"}>
                <label className="data-label">
                    <I18n id="accounts.movements.filters.searchBy" />
                </label>
                <div className="input-group-standard">
                    <Select
                        clearable={false}
                        searchable={false}
                        onChange={this.handleChange}
                        options={options}
                        value={selectedFilter}
                        optionClassName="needsclick"
                    />
                </div>
            </div>
        );
    };

    renderFilter = () => {
        const { selectedFilter } = this.state;
        const {
            dispatch,
            productId,
            setBalanceFalse,
            setBalanceTrue,
            parentSelectedFilter,
            handleClickHideFilters,
            currency,
        } = this.props;

        let props = {
            dispatch,
            isDesktop: true,
            productId,
            setBalanceFalse,
            setBalanceTrue,
            parentSelectedFilter,
            selectedFilter,
            handleClickHideFilters,
            searchByField: this.searchByField,
        };

        if (selectedFilter === "amount") {
            props = {
                ...props,
                currency,
                FieldType: AmountField,
                filterType: "text",
                formID: "accounts.movements.filters.amount",
                fixedDecimalScale: true,
            };
        } else if (selectedFilter === "receipt") {
            props = {
                ...props,
                FieldType: TextField,
                filterType: "text",
                filterName: "receipt",
                formID: "accounts.movements.filters.receipt",
                receipt: "",
            };
        } else if (selectedFilter === "detail") {
            props = {
                ...props,
                FieldType: TextField,
                filterType: "text",
                filterName: "detail",
                formID: "accounts.movements.filters.detail",
                detail: "",
            };
        }

        return selectedFilter && createElement(components[selectedFilter], props);
    };

    render() {
        return <>{this.renderFilter()}</>;
    }
}

const mapStateToProps = (state) => ({
    filtersGlobal: accountsSelectors.getFilters(state),
});

export default connect(mapStateToProps)(MoreFilters);
